import styled from '@emotion/styled'
import { Radio } from 'antd'

export const RadioGroup = styled(Radio.Group)``
